<template>
  <div v-if="this.lightbox.show" class="lightbox">
    <div class="lightbox__overlay" @click="setLightbox({ show: false })"></div>
    <div class="lightbox__modal" @scroll="verifyContentHeight">
      <button class="lightbox__close" @click="setLightbox({ show: false })" aria-label="Botão para fechar modal">
        <i class="icon__go-back"></i>
        voltar
      </button>
      <h5 class="lightbox__title title">{{ this.lightbox.title }}</h5>
      <div class="lightbox__content" v-html="this.lightbox.content"></div>
      <button v-if="showLastGoBack" class="lightbox__close" @click="setLightbox({ show: false })" aria-label="Botão para fechar modal">
        <i class="icon__go-back"></i>
        voltar
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "Lightbox",
  data() {
    return {
      showLastGoBack: false
    };
  },
  computed: {
    ...mapState(["lightbox"])
  },
  methods: {
    ...mapActions(["setLightbox"]),
    verifyContentHeight() {
      if (!this.showLastGoBack) {
        const modalHeight = document.querySelector(".lightbox__modal")
          .offsetHeight;
        const contentHeight = document.querySelector(".lightbox__content")
          .offsetHeight;
        this.showLastGoBack = contentHeight > modalHeight;
      }
    }
  }
};
</script>

<style lang="scss">
.lightbox {
  position: fixed;
  top: 0;
  left: 0;
  @include fade-in;
  z-index: 5;

  &__overlay {
    width: 100vw;
    height: 100vh;
    background: $color__overlay;
  }
  &__modal {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 70%;
    padding: $space__st;
    background: $color__white;
    box-shadow: $shadow__modal;
    transform: translate(-50%, -50%);
    overflow-y: auto;

    @include breakpoint($tablet__min--sm) {
      width: 80%;
      height: 80%;
      min-height: 50%;
    }

    @include breakpoint($desk__min--sm) {
      width: 50%;
    }
  }
  &__close {
    width: auto;
    margin-bottom: $space__md;
    padding: $space__sm 0;
    color: $color__primary;
    text-align: left;
    text-transform: uppercase;
    font-weight: 700;

    .icon__go-back {
      display: block;
    }
  }
  &__content {
    > * {
      margin-bottom: $space__md;
    }
    p {
      text-align: justify;
      text-indent: $space__md;
    }
  }
}
</style>
